<template>
  <vue-cookie-accept-decline
    :ref="'myPanel1'"
    :elementId="'myPanel1'"
    :debug="false"
    :position="'bottom-left'"
    :type="'floating'"
    :disableDecline="true"
    :transitionName="'slideFromBottom'"
    :showPostponeButton="false"
    @status="cookieStatus"
    @clicked-accept="cookieClickedAccept"
    @clicked-decline="cookieClickedDecline"
  >
    <div slot="message">
      Wir setzen für unsere Bezahlmethoden technische Cookies
      <b-icon icon="cookie" size="is-small"></b-icon> ein. Mehr Details gibt es
      auf unserer <router-link to="/datenschutz">Datenschutzseite</router-link>.
    </div>
    <div slot="acceptContent">
      Okay. Verstanden.
    </div>
  </vue-cookie-accept-decline>
</template>

<script>
import VueCookieAcceptDecline from "vue-cookie-accept-decline";

export default {
  name: "cookie",
  components: {
    VueCookieAcceptDecline
  },
  data() {
    return {
      status: null
    };
  },
  methods: {
    cookieStatus(status) {
      //console.log("status: " + status);
      this.status = status;
    },
    cookieClickedAccept() {
      //console.log("here in accept");
      this.status = "accept";
    },
    cookieClickedDecline() {
      //console.log("here in decline");
      this.status = "decline";
    },
    cookieClickedPostpone() {
      //console.log("here in postpone");
      this.status = "postpone";
    },
    cookieRemovedCookie() {
      //console.log("here in cookieRemoved");
      this.status = null;
      this.$refs.myPanel1.init();
    },
    removeCookie() {
      //console.log("Cookie removed");
      this.$refs.myPanel1.removeCookie();
    }
  },
  computed: {
    statusText() {
      return this.status || "No cookie set";
    }
  }
};
</script>

<style lang="scss">
.cookie__floating {
  -ms-overflow-style: none;
  position: fixed;
  overflow: hidden;
  box-sizing: border-box;
  z-index: 9999;
  width: 90%;
  background: $dark;
  color: $white;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  box-shadow: 0 4px 8px rgba(198, 198, 198, 0.3);
  border: none;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 4px;
  bottom: 10px;
  left: 0;
  right: 0;
  margin: 0 auto;
}
@media (min-width: 769px) {
  .cookie__floating {
    max-width: 300px;
  }
  .cookie__floating--bottom-left {
    bottom: 20px;
    left: 20px;
    right: auto;
    margin: 0 0;
  }
  .cookie__floating--bottom-right {
    bottom: 20px;
    right: 20px;
    left: auto;
    margin: 0 0;
  }
  .cookie__floating--top-right {
    top: 20px;
    bottom: auto;
    right: 20px;
    left: auto;
    margin: 0 0;
  }
  .cookie__floating--top-left {
    top: 20px;
    bottom: auto;
    right: auto;
    left: 20px;
    margin: 0 0;
  }
}
.cookie__floating__postpone-button {
  display: inline-flex;
  padding: 5px 0 0 20px;
  margin-bottom: -10px;
  margin-right: auto;
}
.cookie__floating__postpone-button:hover {
  opacity: 0.8;
  cursor: pointer;
}
.cookie__floating__content {
  font-size: 1rem;
  margin-bottom: 5px;
  padding: 15px 20px;
  max-height: 105px;
  overflow: auto;
}
@media (min-width: 769px) {
  .cookie__floating__content {
    margin-bottom: 10px;
  }
}
.cookie__floating__buttons {
  transition: all 0.2s ease;
  display: flex;
  flex-direction: row;
  height: auto;
  width: 100%;
}
.cookie__floating__buttons__button {
  background-color: $white;
  font-weight: bold;
  font-size: 1rem;
  width: 100%;
  min-height: 40px;
  white-space: nowrap;
  user-select: none;
  border-bottom: none;
  border-top: none;
  border-left: none;
  border-right: none;
  padding: 0.375rem 0.75rem;
}
.cookie__floating__buttons__button:first-child {
  border-right: none;
}
.cookie__floating__buttons__button:hover {
  cursor: pointer;
  text-decoration: none;
}
.cookie__floating__buttons__button--accept {
  background: $info;
  color: $white;
  -ms-flex: 1 1 auto;
}
.cookie__floating__buttons__button--accept:hover {
  background: $white;
  color: $primary;
}
.cookie__floating__buttons__button--decline {
  color: $primary;
  -ms-flex: 1 1 auto;
}
.cookie__floating__buttons__button--decline:hover {
  background: $primary;
  color: $white;
}
.slideFromBottom-enter,
.slideFromBottom-leave-to {
  transform: translate(0px, 10em);
}
.slideFromBottom-enter-to,
.slideFromBottom-leave {
  transform: translate(0px, 0px);
}
.slideFromBottom-enter-active {
  transition: transform 0.2s ease-out;
}
.slideFromBottom-leave-active {
  transition: transform 0.2s ease-in;
}
.slideFromTop-enter,
.slideFromTop-leave-to {
  transform: translate(0px, -10em);
}
.slideFromTop-enter-to,
.slideFromTop-leave {
  transform: translate(0px, 0px);
}
.slideFromTop-enter-active {
  transition: transform 0.2s ease-out;
}
.slideFromTop-leave-active {
  transition: transform 0.2s ease-in;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
